import React from 'react'
import styles from './styles.css'
import {Link} from 'react-router-dom'
import { MdAccountBalanceWallet } from 'react-icons/md'
import { MdMonetizationOn } from 'react-icons/md'
import { MdCompare } from 'react-icons/md'

export default class Currencies extends React.Component {
  static propTypes = {}

  renderProduct(Icon, path, title, description) {
    return (
      <Link to={path} className={styles.currency}>
        <div className={styles.icon}>
          <Icon size={60} />
        </div>
        <div className={styles.content}>
          <div className={styles.name}>{title}</div>
          <div className={styles.description}>{description}</div>
        </div>
      </Link>
    )
  }

  render() {
    return (
      <div className={styles.container}>
        {this.renderProduct(
          MdAccountBalanceWallet,
          'https://www.orionx.com/es/wallet/',
          'Billetera',
          'Almacenamiento seguro de cryptomonedas'
        )}
        {this.renderProduct(
          MdMonetizationOn,
          'https://www.orionx.com/es/instant/',
          'Compra / Venta',
          'Compra y venta de cryptomonedas de la forma más simple'
        )}
        {this.renderProduct(
          MdCompare,
          'https://www.orionx.com/es/exchange/',
          'Exchange',
          'La plataforma más avanzada para la compra y venta de cryptomonedas de latinoamerica'
        )}
      </div>
    )
  }
}
